<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "FuncLayout"
}
</script>

<style scoped>

</style>